import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import './style.scss';
import PropTypes from 'prop-types';
import { Drawer } from 'antd';
import AddressActions from '@Actions/addressActions';
import {
  EditOutlined,
} from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import Helpers from '@Apis/helpers';
import NewAddressForm from '@Components/Common/FormUtils/NewAddressForm';
import UpdateAddressForm from '@Components/Common/FormUtils/UpdateAddressForm';

/**
 *
 */
class CustomerAddresses extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  /**
   *
   */
  componentDidMount() {

  }

  /**
   *
   * @param {*} props
   * @param {*} state
   * @return
   */
  static getDerivedStateFromProps(props, state) {
    if (props.selectedCustomer?.customer_info?.customer_id !== state.selectedCustomer?.customer_id) {
      props.getAddresses(1, props.selectedCustomer?.customer_info?.customer_id, 'CUSTOMER');
      return {
        ...state,
        selectedCustomer: props.selectedCustomer,
      };
    }
    return state;
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      selectedCustomer, customerAddresses, user, getAddresses, getAddressesLoading,
    } = this.props;
    const {
      showNewAddressModal, selectedAddress, showUpdateAddressModal,
    } = this.state;
    return (
      <Fragment>
        <Drawer
          open={showNewAddressModal}
          onClose={() => this.setState({ showNewAddressModal: false, selectedAddressType: '' })}
          width="360"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '311px' }}>
              <H3Text text="Add New Address" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showNewAddressModal: false })} />
            </div>
          </div>
          {' '}
          <NewAddressForm
            entityType="CUSTOMER"
            entityId={selectedCustomer?.customer_id}
            user={user}
            seller={selectedCustomer}
            callback={
              () => {
                this.setState({ showNewAddressModal: false });
                getAddresses(1, selectedCustomer?.customer_id, 'CUSTOMER');
              }
            }
            tenantId={user?.tenant_info?.tenant_id}
          />
        </Drawer>
        <Drawer
          open={showUpdateAddressModal}
          onClose={() => this.setState({ showUpdateAddressModal: false })}
          width="360"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '311px' }}>
              <H3Text text="Update Address" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showUpdateAddressModal: false })} />
            </div>
          </div>
          <UpdateAddressForm
            addressType="CUSTOMER"
            user={user}
            addressObject={selectedAddress}
            seller={selectedCustomer}
            callback={
              () => {
                this.setState({ showUpdateAddressModal: false, selectedAddressObject: null });
                getAddresses(1, selectedCustomer.customer_id, 'CUSTOMER');
              }
            }
            tenantId={user?.tenant_info?.tenant_id}
          />
        </Drawer>
        <div className="customer-addresses__wrapper">
          <div className="customer-addresses__header">
            <div className="customer-addresses__heading">
              ADDRESSES
            </div>
            {Helpers.getPermission(Helpers.permissionEntities.CUSTOMER, Helpers.permissionTypes.UPDATE, user) && (
              <div className="customer-addresses__sub" onClick={() => this.setState({ showNewAddressModal: true })}>
                + Add New
              </div>
            )}
          </div>
          <div className="customer-addresses__comments">
            {getAddressesLoading
              ? (
                <React.Fragment>
                  {[1, 2]?.map((item) => (
                    <div key={item} className="business-overview__loader">
                      <div className="loadingBlock loader-line-user  customer-addresses__comment" />
                    </div>
                  ))}

                </React.Fragment>
              )
              : (
                <React.Fragment>
                  {customerAddresses?.addresses?.map((address) => (
                    <div key={address?.address_id} className="customer-addresses__comment">
                      <div className="customer-addresses__comment-message">
                        {address?.address1}
                        <br />
                        {`${address?.city}, ${address?.state}, ${address?.postal_code}, ${address?.country}`}
                      </div>
                      <div className="customer-addresses__comment-options">
                        {Helpers.getPermission(Helpers.permissionEntities.VENDORS, Helpers.permissionTypes.UPDATE, user) && (
                          <div
                            className="comment-option roundIconButton"
                            onClick={() => this.setState({ showUpdateAddressModal: true, selectedAddress: address })}
                          >
                            <EditOutlined />
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </React.Fragment>
              )}
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, AddressReducer, CustomerReducers,
}) => ({
  user: UserReducers.user,
  getCustomerByIdLoading: CustomerReducers.getCustomerByIdLoading,
  selectedCustomer: CustomerReducers.selectedCustomer,
  customerAddresses: AddressReducer.customerAddresses,
  getAddressesLoading: AddressReducer.getAddressesLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getAddresses: (page, entityId, entityType, addressId) => dispatch(AddressActions.getAddresses(page, entityId, entityType, addressId)),
});

CustomerAddresses.propTypes = {
  selectedCustomer: PropTypes.any,
  user: PropTypes.any,
  customerAddresses: PropTypes.any,
  getAddresses: PropTypes.func,
  getAddressesLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CustomerAddresses));
